import { PerformanceTemplate } from './PerformanceTemplate'
import { withPerformanceTemplate } from './withPerformanceTemplate'

const ConnectedPerformanceTemplate =
  withPerformanceTemplate(PerformanceTemplate)
export { ConnectedPerformanceTemplate as PerformanceTemplate }
